/**
 *
 * ActionPlanCard
 *
 */

import React, { Fragment, useState } from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Menu, Avatar, Tooltip, Popover, Dropdown, Spin, Space  } from "antd"
import { Icon } from "@ant-design/compatible"
import iconoFlecha from "images/iconoFlecha.svg"
import iconoCalendar from "images/calendar.svg"
import { flatMap, map } from "lodash"
import iconWarning from "images/warning.svg"
import pointMenu from "images/three-points-gray.svg"
import ModalDeleteSimple from "../ModalDeleteSimple"
import ActionPlanTask from "../ActionPlanTask"
import ProgressBar from "../ProgressBar"
import ActionPlanTaskForm from "../ActionPlanTaskForm"
import "./index.less"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import { loadTexts, sanitize } from "../../utils/i18n"
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride"
import { CloseSquareOutlined, FileTextOutlined, LinkOutlined } from "@ant-design/icons"
import moment from "moment"
import Onboarding from "../Onboarding"
/* eslint-disable react/prefer-stateless-function */
class ActionPlanCard extends React.Component {
  intl = loadTexts("dashboard")
  state = {
    modalDeleteTaks: false,
    openActionPlan: false,
    task_create: false,
    task_delete: {
      index: null,
      data: {},
    },
    task_loading_details: false,
    task_loading_delete: false,
    task_collaborators: [],
    onboarding: false,
  }

  loadDetailsToTask = async () => {
    woopraTrack("Agregar tarea")
    this.setState({
      task_create: true,
      task_loading_details: true,
    })
    if (this.props.canCreateTask) {
      try {
        const items = await fetchGlobalApi({
          method: "GET",
          endpoint: `action-plans/${this.props.item.id_action_plan}/tasks/create`,
        })
        this.setState({
          task_loading_details: false,
          task_collaborators: items.data.data.result.employees,
        })
      } catch (error) {
        this.setState({ task_loading_details: false })
      }
    }
  }

  renderCreateTask = () => {
    const { task_create, task_loading_details, task_collaborators } = this.state
    if (task_create && task_loading_details) {
      return (
        <div className="loadingSpin">
          <Spin size="large" />
        </div>
      )
    }
    return (
      <div>
        <ActionPlanTaskForm
          style={{ paddingTop: 10, paddingBottom: 15, border: 0 }}
          actionPlan={this.props.item}
          defaultEmployee={this.props.item.id_employee}
          collaborators={task_collaborators}
          onCancel={() => this.setState({ task_create: false })}
          onFinishSave={(result) => {
            this.setState({ task_create: false })
            this.props.onReloadActionPlan(result)
          }}
        />
      </div>
    )
  }

  onDeleteTaks = async () => {
    const { task_delete } = this.state
    this.setState({ task_loading_delete: true })
    try {
      const { item } = this.props
      const result = await fetchGlobalApi({
        method: "DELETE",
        endpoint: `action-plans/${item.id_action_plan}/tasks/${task_delete.data.id_task}`,
      })
      this.props.onReloadActionPlan(result.data.data.result)
      this.setState({
        modalDeleteTaks: false,
        task_loading_delete: false,
        task_delete: { index: null, data: {} },
      })
      returnMessage(result)
    } catch (error) {
      this.setState({
        task_loading_delete: false,
        modalDeleteTaks: false,
      })
      returnMessage(error)
    }
  }
  handleJoyrideCallback = (data) => {
    const { action, index, type } = data;
  
    
    if (action === "next") {
      console.log("El usuario dio siguiente en el paso:", index);
  
    
      if (index === 1) {
       
        alert("Pasaste al paso 2 🚀");
      }
    }
  
    
    if (type === "tour:end") {
      console.log("Tour finalizado");
    }
  };
  render() {
    const { openActionPlan, task_create, modalDeleteTaks } = this.state
    const { item, canEdit, canOpen, styleCard, onClick } = this.props
   
    
    let dimensions = item.dimensions.split("| ")
    dimensions = dimensions.sort()
    const dimensions_visible = flatMap(dimensions, (item) => item).slice(0, 2)
    const dimensions_additional = flatMap(dimensions, (item) => item).slice(
      2,
      dimensions.length
    )
    const not_assigned = item.first_name === null
    const list_tasks = item.tasks.filter((e) => {
      if (item.editable) return true
      if (!e.editable && validRole({ role: [5] })) return false // Ambassador only view your task
      return true
    })

    return (
      <div className="ActionPlanCard-component">
        <div
          className="ActionPlanCard-component-row"
          style={styleCard}
          onClick={onClick}>
          <Tooltip title={item.status.name} placement="right">
            <div
              className="ActionPlanCard-component-border"
              style={{ background: item.status.color }}
            />
          </Tooltip>

          <div className="ActionPlanCard-component-row-header">
            <div className="ActionPlanCard-component-row-header-information">
              <div className="ActionPlanCard-component-row-header-information-dimensions">
                {dimensions_visible.map((d, di) => (
                  <span key={`dimension-name-action-plan-${di}`}>{d}</span>
                ))}
                {dimensions.length > 2 ? (
                  <Fragment>
                    <Popover
                      placement="bottom"
                      content={
                        <div
                          className="collaborators-team-tooltip ActionPlanCard-component-row-header-information-dimensions"
                          style={{
                            maxHeight: 200,
                            display: "block",
                            overflow: "auto",
                            fontSize: 12,
                            margin: "-5px -5px -10px -5px",
                          }}>
                          {map(dimensions_additional, (item, index) => {
                            return (
                              <span
                                style={{
                                  margin: 0,
                                  marginBottom: 5,
                                  display: "table",
                                }}
                                key={index}>
                                {item}
                              </span>
                            )
                          })}
                        </div>
                      }
                      style={{ display: "block" }}>
                      <span>...</span>
                    </Popover>
                  </Fragment>
                ) : null}
              </div>
              <div className="ActionPlanCard-component-row-header-information-title">
                <span>{item.action_plan_name}</span>
              </div>
            </div>
            <div className="ActionPlanCard-component-row-header-progress">
              <div className="ActionPlanCard-component-row-header-progress-task">
                <div>
                  <b>{item.total_tasks_done}</b>{" "}
                  <span className="color-gray-low">
                    {this.intl.actionPlanCard.tasks.of} {item.total_tasks}{" "}
                    {this.intl.actionPlanCard.tasks.tasks}
                  </span>
                </div>
                <div>{`${item.progress}%`}</div>
              </div>
              <ProgressBar
                custom={{
                  value: item.progress,
                  color: "#378FEE",
                }}
              />
            </div>
            <div className="ActionPlanCard-component-row-header-options">
              {canEdit && (
                <Dropdown
                  trigger={["click"]}
                  placement="bottomRight"
                  overlay={
                    <Menu>
                      <Menu.Item onClick={(e) => this.props.onEdit(e)}>
                        {this.intl.actionPlanCard.actions.edit}
                      </Menu.Item>
                      <Menu.Item onClick={(e) => this.props.onArchive(e)}>
                        {this.intl.actionPlanCard.actions.archive}
                      </Menu.Item>
                    </Menu>
                  }>
                  <img className={`stepEvidence-1${this.props.index ?? ""}`}
                    style={{ cursor: "pointer", padding: 5 }}
                    src={pointMenu}
                  />
                </Dropdown>
              )}
              {canOpen && (
                <div
                  className="ActionPlanCard-component-row-header-options-icon-right"
                  onClick={() => {
                    this.setState({ openActionPlan: !openActionPlan })
                  }}>
                  <img
                    src={iconoFlecha}
                    style={
                      openActionPlan
                        ? { transform: "rotate(270deg)" }
                        : { transform: "rotate(180deg)" }
                    }
                  />
                </div>
              )}
            </div>
          </div>
          <div className="ActionPlanCard-component-row-header-information-subtitle">
            {// Ocultaremos si es embajador.
            !item.is_ambassador && (
              <Fragment>
                <div className="ActionPlanCard-component-row-header-information-subtitle-user">
                  {not_assigned ? (
                    <Fragment>
                      <Avatar
                        size={21}
                        src={iconWarning}
                        style={{
                          display: "inline-block",
                          verticalAlign: "middle",
                          margin: "0 -1px",
                        }}
                      />
                      <span
                        className="string_dots"
                        style={{
                          width: "calc(100% - 19px)",
                          color: "#E37879",
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}>
                        {this.intl.actionPlanCard.notAssigned}
                      </span>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <Avatar
                        size={16}
                        src={item.profile_picture}
                        style={{ display: "inline-block" }}
                      />
                      <span
                        className="string_dots"
                        style={{
                          width: "calc(100% - 19px)",
                          display: "inline-block",
                          verticalAlign: "bottom",
                        }}>
                        {`${item.first_name} ${item.last_name}`}
                      </span>
                    </Fragment>
                  )}
                </div>
                <div className="ActionPlanCard-component-row-header-information-subtitle-dot">
                  ・
                </div>
              </Fragment>
            )}

            <div className="string_dots">{item.division_name}</div>
            <div className="ActionPlanCard-component-row-header-information-subtitle-dot">
              ・
            </div>
            <div className="ActionPlanCard-component-row-header-information-subtitle-calendar">
              <Tooltip
                placement="bottom"
                title={
                  item.date_transform.indexOf("/") > -1 ||
                  item.date_transform.indexOf("hoy") > -1 ? null : (
                    <div>
                      <b>{this.intl.actionPlanCard.endDate}:</b> {item.date_end}
                    </div>
                  )
                }>
                <img
                  width={11}
                  style={{ marginRight: 5 }}
                  src={iconoCalendar}
                />
                <span>
                  {item.date_transform.indexOf("/") > -1
                    ? `${this.intl.actionPlanCard.endDate}:`
                    : `${this.intl.actionPlanCard.expires}`}{" "}
                  <b style={{ color: item.active_date_red ? "#E37879" : null }}>
                    {item.date_transform}
                  </b>
                </span>
                
                  
                 
                   
              </Tooltip>
            </div>
            <div className="ActionPlanCard-component-row-header-information-subtitle-dot">
              ・
            </div>
            <div className="ActionPlanCard-component-row-header-information-subtitle-user">
            <FileTextOutlined  />
                    <span style={{marginLeft:3}}>{`${this.intl.actionPlanCard.evidences}:`}</span>
                    <span className={`stepEvidence-2${this.props.index ?? ""}`} style={{fontWeight:600}}>{`  ${item.evidences 
                    ?  item.evidences.length 
                    : null}`}</span>
            </div>
          </div>
          {openActionPlan && (
            <Fragment>
              <div
                className="ActionPlanCard-component-row-header-body"
                style={{
                  display: "grid",
                  gridTemplateColumns: "70% auto 35px",
                }}>
                <p>{item.description}</p>
              </div>
              <div className="ActionPlanCard-component-row-header-information-subtitle">
                <div className="ActionPlanCard-component-row-header-information-subtitle-user">
                  <span>
                    {this.intl.actionPlanCard.createBy}{" "}
                    {item.created_by_first_name} {item.created_by_last_name}.
                  </span>
                </div>
                <div
                  className="ActionPlanCard-component-row-header-information-subtitle-dot"
                  style={{ margin: "0 5px" }}>
                  |
                </div>
                <div>
                  {this.intl.actionPlanCard.measure}: {item.measure_name}
                </div>
              </div>
            </Fragment>
          )}
        </div>
        {openActionPlan && (
        <>
          <div
            className="ActionPlanCard-component-row"
            style={{
              backgroundColor: "#F8F9FC",
              borderTop: "1px solid #EDE9E9",
            }}>
            <div className="ActionPlanCard-component-row-tasks">
              <span style={{ fontSize: 13, fontWeight: 600, marginLeft: 10 }}>
                Tareas
              </span>

              {list_tasks.map((t, ti) => (
                <ActionPlanTask
                  canEdit={
                    item.editable ||
                    t.editable ||
                    validRole({ role: [1, 2, 3, 4] })
                  }
                  actionPlan={item}
                  key={`action-plan-task-${ti}`}
                  data={t}
                  onDelete={() =>
                    this.setState({
                      modalDeleteTaks: true,
                      task_delete: { data: t, index: ti },
                    })
                  }
                  onUpdateTask={(result) => {
                    this.props.onReloadActionPlan(result);
                  }}
                  onUpdateActionPlan={(result) => {
                    this.props.onReloadActionPlan(result);
                  }}
                />
              ))}

              {this.props.canCreateTask &&
                !task_create &&
                validRole({ role: [1, 2, 3, 4] }) && (
                  <div
                    style={{
                      color: "#378FEE",
                      marginTop: 4,
                      fontSize: 13,
                      cursor: "pointer",
                      padding: "6px 14px 10px",
                    }}
                    onClick={this.loadDetailsToTask}>
                    + {this.intl.actionPlanCard.actions.addTask}
                  </div>
                )}

              {this.props.canCreateTask &&
                task_create &&
                this.renderCreateTask()}
            </div>
          </div>

          {item.evidences && item.evidences.length > 0 && (
            <div
              className="ActionPlanCard-component-row"
              style={{
                backgroundColor: "#F8F9FC",
                borderTop: "1px solid #EDE9E9",
              }}
            >
              <div className="ActionPlanCard-component-row-tasks" style={{marginTop:-5, marginBottom:-5}}>
              <span style={{ fontSize: 13, fontWeight: 600, marginLeft: 10 }}>
                Evidencias
              </span>
              <div className="evidence-list">
                                {item.evidences.map((ev) => {
                                  const clickable = ev.url.startsWith("http")
                                    return (
                                      <div
                                        id={`evidenceList-${ev.id_evidence}`}
                                        className="evidence-item"
                                        onClick={() =>
                                          clickable &&
                                          window.open(ev.url, "_blank")
                                        }
                                        style={{
                                          borderRadius: 6,
                                          marginBottom: 8,
                                          marginLeft: 10,
                                          cursor: clickable
                                            ? "pointer"
                                            : "default",
                                          backgroundColor: clickable
                                            ? "#FAFAFA"
                                            : "#F8F9FC",
                                        }}
                                        onMouseEnter={(e) => {
                                          if (clickable)
                                            e.currentTarget.style.background =
                                              "#EBF5FF"
                                        }}
                                        onMouseLeave={(e) => {
                                          if (clickable)
                                            e.currentTarget.style.background =
                                              "#F8F9FC"
                                        }}>
                                        <div className="row-between">
                                          <div className="row-between">
                                            <Space size={6}>
                                              <Tooltip title={ev.title}>
                                                <span style={{fontSize:13}}>
                                                  <LinkOutlined
                                                    style={{ marginRight: 6 }}
                                                  />
                                                  {ev.title.length > 28
                                                    ? ev.title.slice(0, 28) +
                                                      "..."
                                                    : ev.title}
                                                </span>
                                              </Tooltip>
                                            </Space>
                                          </div>
                                          <div
                                            style={{
                                              right: 10,
                                              top: 8,
                                            }}>
                                          </div>
                                        </div>

                                        <Tooltip title={ev.url} style={{marginLeft:20}}>
                                          <div className="span-small">
                                            {ev.url.length > 42
                                              ? ev.url.slice(0, 42) + "..."
                                              : ev.url}
                                          </div>
                                        </Tooltip>
                                      </div>
                                    )
                                   
                                })}
                              </div>
                </div>
            </div>
          )}
        </>
      )}
  
       
        <ModalDeleteSimple
          visible={modalDeleteTaks}
          content={
            <Fragment>
              <p>{this.intl.actionPlanCard.deleteModal.title}</p>
            </Fragment>
          }
          loading={this.state.task_loading_delete}
          onOk={() => {
            this.onDeleteTaks()
          }}
          onCancel={() => this.setState({ modalDeleteTaks: false })}
        />
      {}
      {this.props.index == 0 && <Onboarding section="pda-evidence" />}

       
      </div>
      
    )
  }
}

ActionPlanCard.propTypes = {}
ActionPlanCard.defaultProps = {
  onEdit: () => {},
  onArchive: () => {},
  onReloadActionPlan: () => {},
  onClick: () => {},
  styleCard: {},
}

export default ActionPlanCard
